module.exports = __webpack_public_path__ + "static/reviewer2-500x500-0455953126adcc54eb888dc498788bbd.jpg";